import * as Sentry from "@sentry/vue";

export function addSentryTo(app:any, router:any) {
    if(window.location.hostname.endsWith('.test')) {
        return;
    }

    Sentry.init({
        app,
        dsn: "https://1cb0df8f267e4c7dbb6c1f8f104f43b3@o48785.ingest.sentry.io/6237606",
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            }),
            new Sentry.Replay(),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: ["localhost", "dash.zapin.test", /^https:\/\/yourserver\.io\/api/],

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        tracingOptions: {
            trackComponents: true,
        }
    });
}